import React, { useState, useEffect } from 'react';
import { Play, Info, ChevronLeft, ChevronRight, Volume2, VolumeX, Eye, Heart, MessageSquare } from 'lucide-react';

import { useRef } from 'react'; // Não esqueça de importar lá em cima junto com o useState

import YouTubeBackgroundPlayer from '../common/YouTubeBackgroundPlayer'; // ajuste o caminho se necessário

const formatCount = (count?: number) => {
  if (count === undefined || count === null || isNaN(count)) return '0';
  if (count >= 1000000) return (count / 1000000).toFixed(1).replace('.', ',') + 'M';
  if (count >= 1000) return (count / 1000).toFixed(1).replace('.', ',') + ' mil';
  return count.toString();
};

const extractYouTubeId = (urlOrId?: string): string => {
  if (!urlOrId) return '';
  const trimmed = String(urlOrId).trim();
  if (trimmed.length === 11 && !trimmed.includes('/') && !trimmed.includes('.')) return trimmed;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = trimmed.match(regExp);
  return (match && match[2].length === 11) ? match[2] : '';
};

export default function HeroBannerDesktop({ videos, onPlay, onInfo }: { videos: any[], onPlay: (id: string) => void, onInfo: (id: string) => void }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMuted, setIsMuted] = useState(true);
  const [showFullDesc, setShowFullDesc] = useState(false); // 👈 Estado para abrir a descrição completa e curiosidades

  const bannerVideos = videos.filter(v => v.post_type !== 'feed' && v.post_type !== 'app_movel').slice(0, 7);

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const [showVideo, setShowVideo] = useState(false);

  // 👈 ADICIONE ESTE BLOCO LOGO ABAIXO DOS ESTADOS:
  useEffect(() => {
    setShowVideo(false);
    setIsMuted(true); // 👈 ADICIONE ESTA LINHA AQUI
    const timer = setTimeout(() => {
      setShowVideo(true);
      
   }, 5000); // 5 segundos de capa estática
  return () => clearTimeout(timer);
}, [currentIndex]);

  const toggleMute = () => {
    if (!iframeRef.current || !iframeRef.current.contentWindow) return;

    if (isMuted) {
      // Queremos LIGAR o som
      iframeRef.current.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: 'unMute', args: [] }),
        '*'
      );
      setIsMuted(false);
    } else {
      // Queremos DESLIGAR o som
      iframeRef.current.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: 'mute', args: [] }),
        '*'
      );
      setIsMuted(true);
    }
  };
  // Troca automática a cada 60 segundos (reseta o expansor ao trocar)
  useEffect(() => {
    if (bannerVideos.length <= 1) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % bannerVideos.length);
      setShowFullDesc(false);
    }, 90000);
    return () => clearInterval(timer);
  }, [bannerVideos.length]);

  if (bannerVideos.length === 0) return null;

  const currentVideo = bannerVideos[currentIndex];
  const videoUrl = currentVideo.embed_id || currentVideo.full_video_id || currentVideo.trailer_url || currentVideo.url;
  const ytId = extractYouTubeId(videoUrl);

  const handlePrev = () => { setCurrentIndex((prev) => (prev === 0 ? bannerVideos.length - 1 : prev - 1)); setShowFullDesc(false); };
  const handleNext = () => { setCurrentIndex((prev) => (prev + 1) % bannerVideos.length); setShowFullDesc(false); };

  // Pega a descrição do banco (seja description ou sinopse)
  const fullDescription = currentVideo.description || currentVideo.sinopse || 'Assista ao trailer oficial exclusivo na plataforma Doisplay.';

  return (
    <div style={{ 
      position: 'relative', 
      width: '100%', 
      height: '75vh', 
      minHeight: '500px',
      backgroundColor: '#000000', 
      overflow: 'hidden',
      userSelect: 'none'
    }}>
      
      {/* Vídeo Imersivo Gigante à Direita */}
      {/* Vídeo à Direita ou Capa Inicial de 10 segundos */}
      {ytId && showVideo ? (
        <div style={{ position: 'absolute', top: '-15%', right: '-5%', width: '75%', height: '130%', pointerEvents: 'none' }}>
          <iframe
            ref={iframeRef}
            src={`https://www.youtube.com/embed/${ytId}?autoplay=1&mute=1&controls=0&showinfo=0&rel=0&loop=1&playlist=${ytId}&modestbranding=1&enablejsapi=1`}
            style={{ width: '100%', height: '100%', border: 'none' }}
            allow="autoplay; encrypted-media"
            title="Desktop Video"
          />
        </div>
      ) : (
        <img src={currentVideo.thumbnail} alt="Capa" style={{ position: 'absolute', top: 0, right: 0, width: '65%', height: '100%', objectFit: 'cover' }} />
      )}

     {/* Máscara de Degradê Esquerda Suavizada */}
<div style={{
  position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
  background: `
    linear-gradient(to right, #000000 20%, rgba(0, 0, 0, 0.99) 45%, rgba(0, 0, 0, 0.32) 70%, transparent 100%),
    linear-gradient(to top, #000000 0%, rgba(0,0,0,0.5) 15%, transparent 35%)
  `,
  pointerEvents: 'none'
}} />

      {/* Botão de Som PC */}
      {ytId && (
        <button
          onClick={toggleMute}
          style={{
            position: 'absolute', top: '25px', right: '35px', zIndex: 30,
            backgroundColor: 'rgba(0,0,0,0.6)', border: '1px solid rgba(255,255,255,0.2)',
            color: '#fff', borderRadius: '50%', width: '44px', height: '44px',
            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
            transition: 'background 0.2s'
          }}
          title={isMuted ? "Ativar som" : "Desativar som"}
        >
          {isMuted ? <VolumeX size={18} /> : <Volume2 size={18} />}
        </button>
      )}

      {/* Setas Laterais PC */}
      <button 
        onClick={handlePrev}
        style={{
          position: 'absolute', left: '20px', top: '50%', transform: 'translateY(-50%)',
          zIndex: 20, backgroundColor: 'rgba(0,0,0,0.5)', border: 'none', color: '#fff',
          width: '30px', height: '40px', borderRadius: '4px', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}
      >
        <ChevronLeft size={28} />
      </button>

      <button 
        onClick={handleNext}
        style={{
          position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)',
          zIndex: 20, backgroundColor: 'rgba(0,0,0,0.5)', border: 'none', color: '#fff',
          width: '40px', height: '50px', borderRadius: '4px', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}
      >
        <ChevronRight size={28} />
      </button>

      {/* Conteúdo Centralizado Verticalmente à Esquerda */}
      <div style={{ 
        position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', 
        display: 'flex', alignItems: 'center', padding: '0 70px', boxSizing: 'border-box'
      }}>
        <div style={{ maxWidth: '580px', zIndex: 10 }}>
          <h4 style={{ color: '#E50914', margin: '0 0 6px 0', fontSize: '12px', fontWeight: '800', letterSpacing: '2px', textTransform: 'uppercase' }}>
            TRAILER EM DESTAQUE
          </h4>
          <h1 style={{ fontSize: 'clamp(32px, 3.5vw, 42px)', fontWeight: '800', color: '#fff', margin: '0 0 10px 0', lineHeight: '1.15' }}>
            {currentVideo.title}
          </h1>

          {/* Descrição e Curiosidades com suporte a Saiba Mais */}
          {/* Descrição Limitada (Apenas Sinopse Curta) */}
          <div style={{ marginBottom: '20px' }}>
            <p style={{ 
              fontSize: '15px', color: '#ccc', lineHeight: '1.5', margin: 0, 
              display: '-webkit-box', 
              WebkitLineClamp: 3, /* Limita rigidamente a 3 linhas */
              WebkitBoxOrient: 'vertical', 
              overflow: 'hidden',
              textShadow: '1px 1px 3px rgba(0,0,0,0.8)'
            }}>
              {fullDescription}
            </p>
          </div>

          {/* Botões de Ação */}
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '20px' }}>
            <button 
              onClick={() => onPlay(currentVideo.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px', 
                backgroundColor: '#fff', color: '#000', border: 'none', 
                padding: '12px 28px', borderRadius: '4px', fontSize: '15px', fontWeight: 'bold', cursor: 'pointer'
              }}>
              <Play size={18} fill="#000" /> Reproduzir
            </button>
            <button 
              onClick={() => onInfo(currentVideo.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px',
                backgroundColor: 'rgba(255,255,255,0.25)', color: '#fff', border: 'none', 
                padding: '12px 24px', borderRadius: '4px', fontSize: '15px', fontWeight: 'bold', cursor: 'pointer'
              }}>
              <Info size={18} /> Detalhes
            </button>
          </div>

          {/* Métricas abaixo dos botões */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', color: '#bbb', fontSize: '14px', fontWeight: '600' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Eye size={18} color="#aaa" /> {formatCount(currentVideo.views_count || 0)}
            </span>
            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Heart size={18} color="#E50914" fill="#E50914" /> {formatCount(currentVideo.likes_count || 0)}
            </span>
            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <MessageSquare size={18} color="#3b82f6" /> {formatCount(currentVideo.comments_count || 0)}
            </span>
          </div>
        </div>
      </div>

      {/* Indicadores Rodapé PC */}
      <div style={{
        position: 'absolute', bottom: '15px', left: '50%', transform: 'translateX(-50%)',
        display: 'flex', gap: '6px', zIndex: 20
      }}>
        {bannerVideos.map((_, idx) => (
          <div 
            key={idx}
            onClick={() => { setCurrentIndex(idx); setShowFullDesc(false); }}
            style={{
              width: idx === currentIndex ? '22px' : '6px',
              height: '6px', borderRadius: '3px',
              backgroundColor: idx === currentIndex ? '#E50914' : 'rgba(255,255,255,0.4)',
              cursor: 'pointer'
            }}
          />
        ))}
      </div>

    </div>
  );
}